import { render } from "./publish-toggle.vue?vue&type=template&id=cab29a14&lang=pug"
import script from "./publish-toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./publish-toggle.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__